import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { colors } from 'app/shared/theme/colors';

// ─── Translations ───────────────────────────────────────────────

const translations = {
  vi: {
    header: {
      home: 'Trang chủ',
      deposit: 'Nạp tiền',
      order: 'Đơn hàng',
      tools: 'Công cụ',
      promotions: 'Khuyến mãi',
      apiDocs: 'API Docs',
      balance: 'Số dư',
      login: 'Đăng nhập',
      register: 'Đăng ký',
      logout: 'Đăng xuất',
      userMenu: {
        profile: 'Thông tin cá nhân',
        membership: 'Hạng thành viên',
        deposit: 'Nạp tiền',
        order: 'Đơn hàng',
      },
    },
    hero: {
      systemOnline: 'Hệ thống đang hoạt động',
      title: 'Nguồn cung cấp',
      titleHighlight: 'tài nguyên Marketing',
      titleSuffix: 'hàng đầu',
      description:
        'Cung cấp tài khoản email chất lượng cao phục vụ marketing và quảng cáo. Mỗi tài khoản chỉ bán một lần duy nhất. Dữ liệu tự động xoá sau 48h.',
      viewProducts: 'Xem sản phẩm ↓',
      terms: 'Điều khoản →',
      statProducts: 'Sản phẩm',
      statSold: 'Đã bán',
      statCustomers: 'Khách hàng',
      floatSoldToday: 'Đã bán hôm nay',
      floatSecurity: 'Bảo mật',
      floatAutoDelete: 'Tự xoá 48h',
      floatAccountsAvailable: 'Tài khoản sẵn',
    },
    tools: {
      title: 'Công cụ miễn phí',
      checkMail: 'Check Mail',
      checkMailDesc: 'Kiểm tra mail sống/chết',
      getCode: 'Get Code',
      getCodeDesc: 'Lấy mã xác nhận',
      readMailbox: 'Đọc hòm thư',
      readMailboxDesc: 'Xem nội dung email',
      checkUID: 'Check UID',
      checkUIDDesc: 'Kiểm tra UID Facebook',
      get2FA: 'Get 2FA',
      get2FADesc: 'Tạo mã bảo mật',
      registerMail: 'Đăng ký Mail',
      registerMailDesc: 'Tạo tài khoản mới',
      unlockMail: 'Unlock Mail',
      unlockMailDesc: 'Mở khoá mail',
      registerYahoo: 'Đăng ký Yahoo',
      registerYahooDesc: 'Tạo tài khoản Yahoo',
    },
    services: {
      title: 'Bảng giá sản phẩm',
      product: 'Sản phẩm',
      products: 'sản phẩm',
      accounts: 'tài khoản',
      live: 'Live',
      country: 'Quốc gia',
      unitPrice: 'Đơn giá',
      quantity: 'Số lượng',
      buyNow: 'Mua ngay',
      loadMore: 'Tải thêm',
      processingOrder: 'Đang xử lý đơn hàng...',
      purchaseSuccess: 'Mua thành công!',
      orderCode: 'Mã đơn hàng',
      quantityLabel: 'Số lượng',
      totalLabel: 'Tổng',
      copyEmailPass: 'Copy email|pass',
      copyFull: 'Copy full',
      downloadTxt: 'Download .txt',
      buyProduct: 'Mua sản phẩm',
      discount: 'Giảm giá',
      totalAmount: 'Tổng cộng',
      cancel: 'Huỷ',
      confirmBuy: 'Xác nhận mua',
      copySuccess: 'Copy thành công',
      processing: 'Đang xử lý đơn hàng...',
      grandTotal: 'Tổng cộng',
      confirmPurchase: 'Xác nhận mua',
      qty: 'Số lượng',
      total: 'Tổng',
    },
    policy: {
      title: 'Hỗ Trợ và Chính Sách Bảo Hành',
      uniqueAccount: 'Mỗi tài khoản MAIL được bán duy nhất và một lần ( Không chia sẻ )',
      securityNote:
        'Nhằm bảo mật phải đúng thiết bị + trình duyệt đã mua mới có thể xem được dữ liệu và tải xuống. Tất cả Dữ liệu đơn hàng sẽ được tự động xóa sau 24h',
      imapNote:
        'Phương pháp đọc email qua IMAP, POP3 và SMTP ko còn khả dụng nữa để truy cập và đọc được tất cả hòm thư gửi về bạn phải sử dụng phương thức thông qua (OAuth2)',
      oauth2Note:
        'Chúng tôi đã tích hợp đọc mail qua OAuth2 trên website và API để sử dụng khi mua mail bạn tải full định dạng bao gồm Refresh_token và client_id. Mỗi Refresh_token có thời gian tồn tại là 90 ngày; sau 90 ngày, nếu không được làm mới, Refresh_token sẽ không thể sử dụng được nữa',
      item1: 'Mỗi tài khoản MAIL được bán duy nhất và một lần ( Không chia sẻ )',
      item2:
        'Nhằm bảo mật phải đúng thiết bị + trình duyệt đã mua mới có thể xem được dữ liệu và tải xuống. Tất cả Dữ liệu đơn hàng sẽ được tự động xóa sau 24h',
      item3:
        'Phương pháp đọc email qua IMAP, POP3 và SMTP ko còn khả dụng nữa để truy cập và đọc được tất cả hòm thư gửi về bạn phải sử dụng phương thức thông qua (OAuth2)',
      item4:
        'Chúng tôi đã tích hợp đọc mail qua OAuth2 trên website và API để sử dụng khi mua mail bạn tải full định dạng bao gồm Refresh_token và client_id. Mỗi Refresh_token có thời gian tồn tại là 90 ngày; sau 90 ngày, nếu không được làm mới, Refresh_token sẽ không thể sử dụng được nữa',
    },
    contact: {
      issue: 'Gặp vấn đề? Liên hệ:',
      telegram: 'Telegram',
      groupChat: 'Group Chat',
    },
    promotion: {
      vipDiscount: 'Giảm đến 20% cho thành viên VIP',
      viewOffers: 'Xem ưu đãi →',
      registerNow: 'Đăng ký ngay →',
      depositMore: 'Nạp càng nhiều, giảm càng sâu',
      upgradeNow: 'Nâng hạng ngay →',
      joinNow: 'Tham gia ngay →',
    },
    rank: {
      memberRank: 'Hạng thành viên',
      nextRank: 'Hạng tiếp theo',
      viewAll: 'Xem tất cả',
      maxDiscount: 'Giảm giá tối đa',
      registerNow: 'Đăng ký ngay',
      depositNow: 'Nạp tiền ngay',
      viewAllLink: 'Xem tất cả →',
      upgradeToGet: 'Lên',
      toGetDiscount: 'để được giảm',
      discountForMembers: 'cho thành viên',
      register: 'Đăng ký',
      depositNowLink: 'nạp tiền ngay',
      toEnjoyOffers: 'để hưởng ưu đãi →',
      currentRank: 'Hạng hiện tại',
      yourRank: 'Hạng của bạn',
      nextRankBadge: 'Hạng tiếp theo',
      discountPerOrder: 'giảm giá mỗi đơn',
      minDeposit: 'Nạp tối thiểu',
      inDays: 'trong',
      days: 'ngày',
      currentlyUsing: 'Đang sử dụng',
      achieved: 'Đã đạt',
      depositNowCta: 'Nạp ngay →',
      registerCta: 'Đăng ký →',
      bottomNote: 'Hạng được tính dựa trên tổng nạp trong khoảng thời gian quy định. Nếu không đạt điều kiện, hạng sẽ tự động điều chỉnh.',
    },
    rankTiers: {
      title: 'Hạng thành viên &',
      benefits: 'Ưu đãi',
      description: 'Nạp tiền để lên hạng và nhận chiết khấu trên mỗi đơn hàng',
      yourRank: 'Hạng của bạn',
      nextRank: 'Hạng tiếp theo',
      discountPerOrder: 'giảm giá mỗi đơn',
      minDeposit: 'Nạp tối thiểu',
      within: 'trong',
      days: 'ngày',
      currentlyUsing: 'Đang sử dụng',
      achieved: 'Đã đạt',
      depositNow: 'Nạp ngay →',
      registerNow: 'Đăng ký →',
      note: 'Hạng được tính dựa trên tổng nạp trong khoảng thời gian quy định. Nếu không đạt điều kiện, hạng sẽ tự động điều chỉnh.',
    },
    membership: {
      title: 'Hạng thành viên &',
      titleHighlight: 'Ưu đãi',
      subtitle: 'Nạp tiền để lên hạng và nhận chiết khấu trên mỗi đơn hàng',
      currentRankLabel: 'Hạng hiện tại của bạn',
      depositToUpgrade: 'Nạp tiền lên hạng',
      yourRank: 'Hạng của bạn',
      discountPerOrder: 'giảm mỗi đơn',
      comparisonTitle: 'So sánh chi tiết',
      tableRank: 'Hạng',
      tableDiscount: 'Giảm giá',
      tableMinDeposit: 'Nạp tối thiểu',
      tablePeriod: 'Thời gian',
      current: 'Hiện tại',
      faqTitle: 'Câu hỏi thường gặp',
      faqHowRankWorks: 'Hạng được tính như thế nào?',
      faqHowRankWorksAnswer:
        'Dựa trên tổng số tiền bạn nạp trong khoảng thời gian quy định của mỗi hạng. Ví dụ: nạp 1.000.000đ trong 7 ngày → hạng Gold.',
      faqNotEnough: 'Nếu không nạp đủ thì sao?',
      faqNotEnoughAnswer:
        'Hệ thống kiểm tra định kỳ. Nếu tổng nạp trong kỳ không đạt điều kiện, hạng sẽ tự động điều chỉnh về hạng phù hợp (không nhất thiết về mức thấp nhất).',
      faqWhichProducts: 'Giảm giá áp dụng cho sản phẩm nào?',
      faqWhichProductsAnswer: 'Áp dụng cho tất cả sản phẩm, hoặc chỉ một số sản phẩm nhất định tuỳ cấu hình của từng hạng.',
      faqCanSkipRank: 'Có thể nhảy hạng không?',
      faqCanSkipRankAnswer:
        'Có. Nếu bạn nạp đủ điều kiện của hạng cao hơn, bạn sẽ được nâng hạng ngay trong lần kiểm tra tiếp theo (mỗi 5 phút).',
      registerNow: 'Đăng ký ngay →',
      days: 'ngày',
      benefits: 'Ưu đãi',
      description: 'Nạp tiền để lên hạng và nhận chiết khấu trên mỗi đơn hàng',
      currentRank: 'Hạng hiện tại của bạn',
      within: 'trong',
      rank: 'Hạng',
      discount: 'Giảm giá',
      minDeposit: 'Nạp tối thiểu',
      period: 'Thời gian',
      faq1Q: 'Hạng được tính như thế nào?',
      faq1A: 'Dựa trên tổng số tiền bạn nạp trong khoảng thời gian quy định của mỗi hạng. Ví dụ: nạp 1.000.000đ trong 7 ngày → hạng Gold.',
      faq2Q: 'Nếu không nạp đủ thì sao?',
      faq2A: 'Hệ thống kiểm tra định kỳ. Nếu tổng nạp trong kỳ không đạt điều kiện, hạng sẽ tự động điều chỉnh về hạng phù hợp.',
      faq3Q: 'Giảm giá áp dụng cho sản phẩm nào?',
      faq3A: 'Áp dụng cho tất cả sản phẩm, hoặc chỉ một số sản phẩm nhất định tuỳ cấu hình của từng hạng.',
      faq4Q: 'Có thể nhảy hạng không?',
      faq4A: 'Có. Nếu bạn nạp đủ điều kiện của hạng cao hơn, bạn sẽ được nâng hạng ngay.',
    },
    logout: {
      title: 'Đăng xuất thành công',
      redirecting: 'Đang chuyển về trang chủ...',
    },
    login: {
      title: 'Đăng nhập',
      welcome: 'Chào mừng quay trở lại',
      error: 'Đăng nhập thất bại! Vui lòng kiểm tra thông tin và thử lại.',
      usernameLabel: 'Tên đăng nhập',
      usernamePlaceholder: 'Nhập tên đăng nhập',
      usernameRequired: 'Tên đăng nhập không được để trống',
      passwordLabel: 'Mật khẩu',
      passwordPlaceholder: 'Nhập mật khẩu',
      passwordRequired: 'Mật khẩu không được để trống',
      rememberMe: 'Ghi nhớ',
      forgotPassword: 'Quên mật khẩu?',
      submit: 'Đăng nhập',
      noAccount: 'Chưa có tài khoản?',
      register: 'Đăng ký',
    },
    register: {
      title: 'Đăng ký tài khoản',
      usernameLabel: 'Tên đăng nhập',
      usernamePlaceholder: 'Nhập tên đăng nhập',
      usernameRequired: 'Tên đăng nhập không được để trống',
      usernameMinLength: 'Tối thiểu 1 ký tự',
      usernameMaxLength: 'Tối đa 50 ký tự',
      emailLabel: 'Email',
      emailPlaceholder: 'email@example.com',
      emailRequired: 'Email không được để trống',
      passwordLabel: 'Mật khẩu',
      passwordPlaceholder: 'Ít nhất 4 ký tự',
      passwordRequired: 'Mật khẩu không được để trống',
      passwordMinLength: 'Tối thiểu 4 ký tự',
      confirmPasswordLabel: 'Nhập lại mật khẩu',
      confirmPasswordPlaceholder: 'Xác nhận mật khẩu',
      confirmPasswordRequired: 'Nhập lại mật khẩu',
      submit: 'Đăng ký',
      hasAccount: 'Đã có tài khoản?',
      login: 'Đăng nhập',
      loginLink: 'Đăng nhập',
      success: 'Đăng kí thành công',
      minLength1: 'Tối thiểu 1 ký tự',
      maxLength50: 'Tối đa 50 ký tự',
      minLength4: 'Tối thiểu 4 ký tự',
      confirmLabel: 'Nhập lại mật khẩu',
      confirmPlaceholder: 'Xác nhận mật khẩu',
      confirmRequired: 'Nhập lại mật khẩu',
    },
    password: {
      title: 'Đổi mật khẩu',
      accountLabel: 'Tài khoản',
      currentPassword: 'Mật khẩu hiện tại',
      currentPasswordPlaceholder: 'Nhập mật khẩu cũ',
      currentPasswordRequired: 'Mật khẩu không được để trống.',
      newPassword: 'Mật khẩu mới',
      newPasswordPlaceholder: 'Ít nhất 4 ký tự',
      newPasswordRequired: 'Mật khẩu không được để trống.',
      newPasswordMinLength: 'Mật khẩu phải có ít nhất 4 ký tự.',
      newPasswordMaxLength: 'Tối đa 50 ký tự.',
      confirmPassword: 'Nhập lại mật khẩu',
      confirmPasswordPlaceholder: 'Xác nhận mật khẩu mới',
      confirmPasswordRequired: 'Nhập lại mật khẩu.',
      confirmPasswordMismatch: 'Mật khẩu không khớp!',
      submit: 'Lưu mật khẩu',
    },
    passwordReset: {
      initTitle: 'Quên mật khẩu',
      initSubtitle: 'Nhập email đã đăng ký để nhận link đặt lại',
      emailLabel: 'Email',
      emailPlaceholder: 'email@example.com',
      emailRequired: 'Email không được để trống.',
      emailInvalid: 'Email không hợp lệ.',
      sendResetLink: 'Gửi link đặt lại',
      backToLogin: '← Quay lại đăng nhập',
      finishTitle: 'Đặt mật khẩu mới',
      linkInvalid: 'Link không hợp lệ hoặc đã hết hạn',
      newPassword: 'Mật khẩu mới',
      newPasswordPlaceholder: 'Ít nhất 4 ký tự',
      newPasswordRequired: 'Mật khẩu không được để trống.',
      newPasswordMinLength: 'Tối thiểu 4 ký tự.',
      confirmPassword: 'Xác nhận mật khẩu',
      confirmPasswordPlaceholder: 'Nhập lại',
      confirmPasswordRequired: 'Nhập lại mật khẩu.',
      confirmPasswordMismatch: 'Mật khẩu không khớp!',
      saveNewPassword: 'Lưu mật khẩu mới',
    },
    deposit: {
      title: 'Nạp tiền',
      bankMaintenance: 'Ngân hàng đang bảo trì',
      amountLabel: 'Số tiền (VND)',
      amountPlaceholder: 'Nhập số tiền cần nạp...',
      pay: 'Thanh toán',
      depositHistory: 'Lịch sử nạp tiền',
      code: 'Code',
      amount: 'Số tiền',
      status: 'Trạng thái',
      note: 'Ghi chú',
      date: 'Ngày',
      statusSuccess: 'Thành công',
      statusFailed: 'Thất bại',
      statusProcessing: 'Đang xử lý',
      checkStatus: 'Kiểm tra trạng thái',
      success: 'Thành công',
      failed: 'Thất bại',
      processing: 'Đang xử lý',
      noteSuccess: 'Nạp tiền thành công',
      noteFailed: 'Nạp tiền thất bại',
      methodBank: 'Ngân hàng',
      methodCrypto: 'Crypto',
      cryptoHint: 'Chọn mạng & coin ở bước sau.',
    },
    depositDialog: {
      title: 'Nạp tiền',
      creating: 'Đang tạo giao dịch...',
      transferCode: 'Nội dung CK',
      paymentSuccess: 'Thanh toán thành công!',
      waitingPayment: 'Đang chờ thanh toán...',
      autoCheck: 'Tự động kiểm tra mỗi 5 giây',
      error: 'Lỗi',
      cannotCreate: 'Không thể tạo giao dịch',
      successTitle: 'Thành công',
      successText: 'Thanh toán thành công!',
      close: 'Đóng',
      qrAlt: 'QR Code',
      success: 'Thanh toán thành công!',
      waiting: 'Đang chờ thanh toán...',
      expired: 'Hóa đơn đã hết hạn',
      expiredDesc: 'Vui lòng tạo hóa đơn mới',
      createNew: 'Tạo hóa đơn mới',
      remaining: 'Còn lại',
    },
    cryptoDialog: {
      title: 'Nạp bằng Crypto',
      loading: 'Đang tải danh sách coin...',
      disabled: 'Thanh toán crypto chưa được bật',
      pickNetwork: 'Chọn mạng',
      pickCoin: 'Chọn coin',
      amount: 'Số tiền nạp',
      continue: 'Tiếp tục',
      creating: 'Đang tạo đơn...',
      error: 'Lỗi',
      cannotCreate: 'Không thể tạo đơn crypto',
      remaining: 'Còn lại',
      expired: 'Đơn đã hết hạn',
      networkWarning: 'Chỉ gửi',
      viaNetwork: 'qua mạng',
      sendExactly: 'Gửi chính xác',
      address: 'Địa chỉ nhận',
      tapToCopy: 'chạm để copy',
      copy: 'Copy',
      success: 'Đã nhận tiền — nạp thành công!',
      waiting: 'Đang chờ chuyển tiền...',
      received: 'Đã nhận',
      successTitle: 'Thành công',
      successText: 'Đã cộng tiền vào ví!',
      simulate: '[TESTNET] Giả lập đã nhận tiền',
    },
    depositWidget: {
      currentRank: 'Hạng hiện tại',
      progressTo: 'Tiến độ lên',
      depositMore: 'Nạp thêm',
      toUpgrade: 'để lên hạng',
      discountAll: 'Giảm',
      allOrders: 'tất cả đơn hàng',
      highestRank: 'Bạn đã đạt hạng cao nhất!',
      highestRankDiscount: 'Giảm',
      viewDetails: 'Xem chi tiết hạng thành viên →',
    },
    order: {
      adminTitle: 'Quản lý đơn hàng',
      userTitle: 'Lịch sử đơn hàng',
      refresh: 'Làm mới',
      searchPlaceholder: 'Tìm kiếm mã đơn hàng...',
      searchPlaceholderAdmin: 'Tìm theo mã đơn hoặc username...',
      downloadAll: 'Tải tất cả',
      downloadFiltered: 'Tải theo bộ lọc',
      downloading: 'Đang tải...',
      quickFilter: 'Nhanh',
      dateRange: 'Khoảng thời gian',
      apply: 'Áp dụng',
      clear: 'Xoá',
      allTime: 'Tất cả',
      '12h': '12 giờ',
      '24h': '24 giờ',
      '3d': '3 ngày',
      '7d': '7 ngày',
      '30d': '30 ngày',
      selected: 'Đã chọn',
      selectedOrders: 'đơn',
      downloadSelected: 'Tải đã chọn',
      deleteSelected: 'Xoá đã chọn',
      tableHeaders: {
        user: 'User',
        code: 'Mã đơn',
        productId: 'ID SP',
        mailType: 'Loại mail',
        quantity: 'SL',
        total: 'Thành tiền',
        status: 'Trạng thái',
        createdDate: 'Ngày tạo',
      },
      success: 'Thành công',
      failed: 'Thất bại',
      noResults: 'Không tìm thấy đơn hàng phù hợp',
      noOrders: 'Chưa có đơn hàng nào',
      orderDetail: 'Chi tiết đơn hàng',
      orderCodeLabel: 'Mã đơn',
      typeLabel: 'Loại',
      quantityLabel: 'SL',
      totalLabel: 'Tổng',
      copyEmail: 'Copy email|pass',
      copyFull: 'Copy full',
      download: 'Download .txt',
      view: 'Xem',
      downloadShort: 'Tải',
      copySuccess: 'Copy thành công',
      downloadSuccess: 'Đã tải',
      downloadedOrders: 'đơn hàng',
      downloadError: 'Lỗi khi tải',
      noDataToDownload: 'Không có dữ liệu để tải',
      deleteConfirm: 'Xoá',
      deleteConfirmSuffix: 'đơn hàng đã chọn?',
      deleted: 'Đã xoá',
      selectDateRange: 'Vui lòng chọn cả ngày bắt đầu và kết thúc',
      startBeforeEnd: 'Ngày bắt đầu phải trước ngày kết thúc',
    },
    menu: {
      home: 'Trang chủ',
      manageUsers: 'Quản lý user',
      manageBanks: 'Quản lý ngân hàng',
      manageDeposits: 'Quản lý nạp tiền',
      manageOrders: 'Quản lý đơn hàng',
      manageMails: 'Quản lý mail',
      manageRanking: 'Quản lý ranking',
      profile: 'Thông tin cá nhân',
      deposit: 'Nạp tiền',
      orderHistory: 'Lịch sử mua',
    },
    announcement: {
      promotion: 'Khuyến mãi',
      update: 'Cập nhật',
      advertisement: 'Quảng cáo',
      info: 'Thông tin',
      dontShowAgain: 'Không hiển thị lại',
      next: 'Tiếp theo',
      understood: 'Đã hiểu',
    },
    pagination: {
      show: 'Hiển thị',
      perPage: '/ trang',
    },
    footer: {
      copyright: '© 2025 Q8Tools. Nghiêm cấm sử dụng trái pháp luật.',
      terms: 'Điều khoản',
      privacy: 'Bảo mật',
      telegram: 'Telegram ↗',
    },
    authMenu: {
      login: 'Đăng nhập',
      register: 'Đăng ký',
      logout: 'Đăng xuất',
      profile: 'Thông tin cá nhân',
      settings: 'Cài đặt',
    },
    notifications: {
      promotion: 'Khuyến mãi',
      update: 'Cập nhật',
      advertisement: 'Quảng cáo',
      dontShowAgain: 'Không hiển thị lại',
      close: 'Đóng',
    },
    profile: {
      title: 'Thông tin cá nhân',
      account: 'Tài khoản',
      email: 'Email',
      memberRank: 'Hạng thành viên',
      balance: 'Số dư',
      apiKey: 'API Key',
      copiedApiKey: 'Đã copy API Key',
      changePassword: 'Đổi mật khẩu',
      changeApiKey: 'Đổi API Key',
      changeApiKeySuccess: 'Đổi API Key thành công',
      currentRank: 'Hạng hiện tại',
      benefit: 'Ưu đãi',
      totalDepositInPeriod: 'Tổng nạp trong',
      daysAgo: 'ngày qua',
      progressTo: 'Tiến trình lên',
      discount: 'Giảm giá',
      minDeposit: 'Nạp tối thiểu',
      within: 'Trong vòng',
      days: 'ngày',
      depositMoreHint: 'Nạp thêm',
      inDaysToUpgrade: 'ngày để lên hạng',
      andGetDiscount: 'và được giảm',
      highestRank: 'Bạn đã ở hạng cao nhất!',
    },
    toolCommon: {
      complete: 'Hoàn tất',
      errorOccurred: 'Có lỗi xảy ra',
      copySuccess: 'Copy thành công',
      progress: 'Tiến độ',
      lines: 'dòng',
      noResult: 'Chưa có kết quả',
      checking: '⏳ Đang kiểm tra...',
      startCheck: '▶ Bắt đầu kiểm tra',
      processing: '⏳ Đang xử lý...',
    },
    toolCheckMail: {
      mailList: 'Danh sách mail',
      startCheck: '▶ Bắt đầu kiểm tra',
    },
    toolCheckUid: {
      uidList: 'Danh sách UID',
      placeholder: 'UID (mỗi dòng 1 UID)',
      checkLive: '▶ Check live',
    },
    toolGetCode: {
      fillMailList: 'Vui lòng điền danh sách mail',
      selectEmailType: 'Vui lòng chọn loại email',
      stt: 'STT',
      content: 'Nội dung',
      time: 'Thời gian',
      errorBadge: 'Lỗi',
    },
    toolReadMail: {
      title: '📬 Đọc hòm thư',
      reading: '⏳ Đang đọc...',
      readMailbox: '▶ Đọc hòm thư',
      stt: 'STT',
      from: 'Từ',
      preview: 'Xem trước',
      time: 'Thời gian',
      noEmail: 'Không có email',
      view: 'Xem',
    },
    toolGet2fa: {
      placeholder: 'Nhập secret key...',
      getCode: 'Lấy mã',
      clickToCopy: 'Nhấn để copy',
      enterKeyPrompt: 'Nhập key và bấm Lấy mã',
      newCodeIn: 'Mã mới sau',
      seconds: 's',
      errorGet2fa: 'Lỗi lấy mã 2FA',
    },
    toolSuspended: {
      title: 'Chức năng đang tạm ngưng',
      contactAdmin: 'Vui lòng liên hệ admin để biết thêm thông tin',
      contactTelegram: 'Liên hệ Telegram',
    },
    toolRegisterMail: { title: '📝 Đăng ký HotMail' },
    toolUnlockMail: { title: '🔓 Mở khoá HotMail' },
    toolRegisterYahoo: { title: '📨 Đăng ký Yahoo' },
    termPage: {
      title: '📜 Điều khoản sử dụng',
      section1Title: '1. Giới thiệu',
      section1Content: 'Chào mừng bạn đến với Q8Tools. Bằng việc sử dụng dịch vụ, bạn đồng ý tuân thủ các điều khoản dưới đây.',
      section2Title: '2. Dịch vụ',
      section2Content: 'Chúng tôi cung cấp tài khoản email chất lượng cao phục vụ mục đích marketing và quảng cáo hợp pháp.',
      section3Title: '3. Tài khoản',
      section3Content:
        'Mỗi tài khoản email chỉ được bán một lần duy nhất. Người mua chịu trách nhiệm bảo mật thông tin tài khoản của mình.',
      section4Title: '4. Thanh toán',
      section4Content: 'Thanh toán qua chuyển khoản ngân hàng. Số dư đã nạp không hoàn lại.',
      section5Title: '5. Dữ liệu',
      section5Content: 'Dữ liệu đơn hàng sẽ tự động xoá sau 48 giờ. Vui lòng tải về trước thời hạn.',
      section6Title: '6. Trách nhiệm',
      section6Content: 'Chúng tôi không chịu trách nhiệm nếu tài khoản bị khoá do vi phạm chính sách của nhà cung cấp email.',
      section7Title: '7. Liên hệ',
      section7Content: 'Mọi thắc mắc vui lòng liên hệ qua Telegram.',
      contact: 'Liên hệ:',
    },
    policyPage: {
      title: '🔐 Chính sách bảo mật',
      dataWeStore: 'Dữ liệu chúng tôi lưu trữ:',
      email: 'Địa chỉ email của bạn',
      password: 'Mật khẩu đã mã hóa',
      balance: 'Số dư hiện tại',
      depositHistory: 'Lịch sử nạp tiền và chi tiết thanh toán',
      orderHistory: 'Lịch sử mua hàng (72 giờ)',
      deleteAccount: 'Khách hàng có thể xóa tài khoản bằng cách liên hệ qua',
      deleteDelay: '. Việc xóa sẽ được thực hiện không sớm hơn 48 giờ.',
    },
    userProfile: {
      title: '👤 Thông tin cá nhân',
      account: 'Tài khoản',
      memberRank: 'Hạng thành viên',
      balance: 'Số dư',
      apiKey: 'API Key',
      copiedApiKey: 'Đã copy API Key',
      changedApiKey: 'Đổi API Key thành công',
      changePassword: '🔒 Đổi mật khẩu',
      changeApiKey: '🔄 Đổi API Key',
      membershipTitle: '👑 Hạng thành viên',
      currentRank: 'Hạng hiện tại',
      benefit: 'Ưu đãi',
      discount: 'Giảm giá',
      allOrders: 'tất cả đơn hàng',
      totalDeposit: 'Tổng nạp trong',
      daysAgo: 'ngày qua',
      progressTo: 'Tiến trình lên',
      minDeposit: 'Nạp tối thiểu',
      within: 'Trong vòng',
      days: 'ngày',
      depositMore: 'Nạp thêm',
      inDays: 'trong',
      toUpgrade: 'ngày để lên hạng',
      andGetDiscount: 'và được giảm',
      highestRank: 'Bạn đã ở hạng cao nhất!',
    },
    systemSettings: {
      title: 'Cài đặt hệ thống',
      orderGroup: 'Đơn hàng',
      maxRetention: 'Số ngày lưu đơn hàng tối đa',
      maxRetentionDesc: 'Đơn hàng sẽ tự động xóa sau số ngày này',
      save: 'Lưu cài đặt',
      saveSuccess: 'Đã lưu cài đặt',
      days: 'ngày',
      telegramGroup: 'Telegram',
      botToken: 'Bot Token',
      botTokenDesc: 'Token của Telegram Bot',
      chatId: 'Chat ID',
      chatIdDesc: 'ID nhóm chat nhận thông báo',
      enabled: 'Bật thông báo',
      websiteGroup: 'Website',
      siteName: 'Tên website',
      contactTelegram: 'Liên hệ Telegram',
      savedKey: 'Đã lưu',
    },
    orderRetention: {
      title: 'Thời gian lưu đơn hàng',
      description: 'Đơn hàng sẽ tự động xóa sau thời gian bạn chọn',
      day: 'ngày',
      days: 'ngày',
      saveSuccess: 'Đã cập nhật',
      max: 'Tối đa',
      autoDeleteInfo: 'Tự động xóa sau',
      changeInProfile: 'Thay đổi',
    },
    pageNotFound: {
      title: 'Không tìm thấy trang',
      description: 'Trang bạn tìm kiếm không tồn tại hoặc đã bị xoá.',
      backHome: '← Về trang chủ',
    },
    passwordStrength: {
      label: 'Độ mạnh của mật khẩu:',
    },
    headerMisc: {
      login: 'Đăng nhập',
      products: 'Sản phẩm',
    },
    common: {
      cancel: 'Huỷ',
      confirm: 'Xác nhận',
      close: 'Đóng',
      copySuccess: 'Copy thành công',
      error: 'Lỗi',
      loading: 'Đang tải...',
      save: 'Lưu',
      delete: 'Xoá',
      edit: 'Sửa',
      back: 'Quay lại',
      next: 'Tiếp theo',
      previous: 'Trước',
      search: 'Tìm kiếm',
      noData: 'Không có dữ liệu',
      show: 'Hiển thị',
      perPage: '/ trang',
    },
  },
  en: {
    header: {
      home: 'Home',
      deposit: 'Deposit',
      order: 'Orders',
      tools: 'Tools',
      promotions: 'Promotions',
      apiDocs: 'API Docs',
      balance: 'Balance',
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      userMenu: {
        profile: 'Profile',
        membership: 'Membership',
        deposit: 'Deposit',
        order: 'Orders',
      },
    },
    hero: {
      systemOnline: 'System is online',
      title: 'Leading provider of',
      titleHighlight: 'email accounts',
      titleSuffix: 'you can trust',
      description:
        'High-quality email accounts for marketing and advertising. Each account is sold only once. Data is automatically deleted after 48 hours.',
      viewProducts: 'View Products ↓',
      terms: 'Terms →',
      statProducts: 'Products',
      statSold: 'Sold',
      statCustomers: 'Customers',
      floatSoldToday: 'Sold today',
      floatSecurity: 'Security',
      floatAutoDelete: 'Auto-delete 48h',
      floatAccountsAvailable: 'Accounts available',
    },
    tools: {
      title: 'Free Tools',
      checkMail: 'Check Mail',
      checkMailDesc: 'Verify live/dead emails',
      getCode: 'Get Code',
      getCodeDesc: 'Retrieve verification codes',
      readMailbox: 'Read Mailbox',
      readMailboxDesc: 'View email content',
      checkUID: 'Check UID',
      checkUIDDesc: 'Check Facebook UID',
      get2FA: 'Get 2FA',
      get2FADesc: 'Generate security codes',
      registerMail: 'Register Mail',
      registerMailDesc: 'Create new accounts',
      unlockMail: 'Unlock Mail',
      unlockMailDesc: 'Unlock email accounts',
      registerYahoo: 'Register Yahoo',
      registerYahooDesc: 'Create Yahoo accounts',
    },
    services: {
      title: 'Product Pricing',
      product: 'Product',
      products: 'products',
      accounts: 'accounts',
      live: 'Live',
      country: 'Country',
      unitPrice: 'Unit Price',
      quantity: 'Quantity',
      buyNow: 'Buy Now',
      loadMore: 'Load More',
      processingOrder: 'Processing order...',
      purchaseSuccess: 'Purchase Successful!',
      orderCode: 'Order Code',
      quantityLabel: 'Quantity',
      totalLabel: 'Total',
      copyEmailPass: 'Copy email|pass',
      copyFull: 'Copy full',
      downloadTxt: 'Download .txt',
      buyProduct: 'Buy Product',
      discount: 'Discount',
      totalAmount: 'Total',
      cancel: 'Cancel',
      confirmBuy: 'Confirm Purchase',
      copySuccess: 'Copied successfully',
      processing: 'Processing order...',
      grandTotal: 'Total',
      confirmPurchase: 'Confirm Purchase',
      qty: 'Qty',
      total: 'Total',
    },
    policy: {
      title: 'Support & Warranty Policy',
      uniqueAccount: 'Each email account is sold once and exclusively (not shared)',
      securityNote:
        'For security, you must use the same device and browser that was used for purchase to view and download data. All order data is automatically deleted after 24 hours',
      imapNote:
        'Email access via IMAP, POP3 and SMTP is no longer available. To access and read all incoming mail, you must use the OAuth2 method',
      oauth2Note:
        'We have integrated OAuth2 email reading on our website and API. When purchasing email, download the full format including Refresh_token and client_id. Each Refresh_token lasts 90 days; after 90 days without renewal, the Refresh_token will expire',
      item1: 'Each email account is sold once and exclusively (not shared)',
      item2:
        'For security, you must use the same device and browser that was used for purchase to view and download data. All order data is automatically deleted after 24 hours',
      item3:
        'Email access via IMAP, POP3 and SMTP is no longer available. To access and read all incoming mail, you must use the OAuth2 method',
      item4:
        'We have integrated OAuth2 email reading on our website and API. Each Refresh_token lasts 90 days; after 90 days without renewal, the Refresh_token will expire',
    },
    contact: {
      issue: 'Having issues? Contact:',
      telegram: 'Telegram',
      groupChat: 'Group Chat',
    },
    promotion: {
      vipDiscount: 'Up to 20% off for VIP members',
      viewOffers: 'View offers →',
      registerNow: 'Register now →',
      depositMore: 'Deposit more, save more',
      upgradeNow: 'Upgrade now →',
      joinNow: 'Join now →',
    },
    rank: {
      memberRank: 'Member Rank',
      nextRank: 'Next Rank',
      viewAll: 'View All',
      maxDiscount: 'Max Discount',
      registerNow: 'Register Now',
      depositNow: 'Deposit Now',
      viewAllLink: 'View all →',
      upgradeToGet: 'Reach',
      toGetDiscount: 'to get',
      discountForMembers: 'for members',
      register: 'Register',
      depositNowLink: 'deposit now',
      toEnjoyOffers: 'to enjoy benefits →',
      currentRank: 'Current Rank',
      yourRank: 'Your Rank',
      nextRankBadge: 'Next Rank',
      discountPerOrder: 'discount per order',
      minDeposit: 'Minimum deposit',
      inDays: 'within',
      days: 'days',
      currentlyUsing: 'Current',
      achieved: 'Achieved',
      depositNowCta: 'Deposit →',
      registerCta: 'Register →',
      bottomNote:
        'Rank is calculated based on total deposits within the specified period. If conditions are not met, your rank will be automatically adjusted.',
    },
    rankTiers: {
      title: 'Membership &',
      benefits: 'Benefits',
      description: 'Deposit to level up and get discounts on every order',
      yourRank: 'Your Rank',
      nextRank: 'Next Rank',
      discountPerOrder: 'discount per order',
      minDeposit: 'Min Deposit',
      within: 'within',
      days: 'days',
      currentlyUsing: 'Currently Using',
      achieved: 'Achieved',
      depositNow: 'Deposit Now →',
      registerNow: 'Register →',
      note: 'Rank is calculated based on total deposits within the specified period. If conditions are not met, your rank will be automatically adjusted.',
    },
    membership: {
      title: 'Membership &',
      titleHighlight: 'Benefits',
      subtitle: 'Deposit to rank up and receive discounts on every order',
      currentRankLabel: 'Your current rank',
      depositToUpgrade: 'Deposit to Upgrade',
      yourRank: 'Your Rank',
      discountPerOrder: 'off per order',
      comparisonTitle: 'Detailed Comparison',
      tableRank: 'Rank',
      tableDiscount: 'Discount',
      tableMinDeposit: 'Min. Deposit',
      tablePeriod: 'Period',
      current: 'Current',
      faqTitle: 'Frequently Asked Questions',
      faqHowRankWorks: 'How is rank calculated?',
      faqHowRankWorksAnswer:
        'Based on the total amount you deposit within the specified period for each rank. For example: deposit 1,000,000 VND in 7 days to reach Gold.',
      faqNotEnough: "What if I don't deposit enough?",
      faqNotEnoughAnswer:
        "The system checks periodically. If the total deposit in the period doesn't meet the requirement, your rank will be automatically adjusted to the appropriate level (not necessarily the lowest).",
      faqWhichProducts: 'Which products does the discount apply to?',
      faqWhichProductsAnswer: "Applies to all products, or only certain products depending on each rank's configuration.",
      faqCanSkipRank: 'Can I skip ranks?',
      faqCanSkipRankAnswer: "Yes. If you meet the requirements for a higher rank, you'll be upgraded at the next check (every 5 minutes).",
      registerNow: 'Register Now →',
      days: 'days',
      benefits: 'Benefits',
      description: 'Deposit to rank up and receive discounts on every order',
      currentRank: 'Your current rank',
      within: 'within',
      rank: 'Rank',
      discount: 'Discount',
      minDeposit: 'Min. Deposit',
      period: 'Period',
      faq1Q: 'How is rank calculated?',
      faq1A: 'Based on the total amount you deposit within the specified period for each rank.',
      faq2Q: "What if I don't deposit enough?",
      faq2A: 'The system checks periodically. If conditions are not met, your rank will be automatically adjusted.',
      faq3Q: 'Which products does the discount apply to?',
      faq3A: "Applies to all products, or only certain products depending on each rank's configuration.",
      faq4Q: 'Can I skip ranks?',
      faq4A: "Yes. If you meet the requirements for a higher rank, you'll be upgraded at the next check.",
    },
    logout: {
      title: 'Logged out successfully',
      redirecting: 'Redirecting to home page...',
    },
    login: {
      title: 'Login',
      welcome: 'Welcome back',
      error: 'Login failed! Please check your credentials and try again.',
      usernameLabel: 'Username',
      usernamePlaceholder: 'Enter username',
      usernameRequired: 'Username is required',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter password',
      passwordRequired: 'Password is required',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot password?',
      submit: 'Login',
      noAccount: "Don't have an account?",
      register: 'Register',
    },
    register: {
      title: 'Create Account',
      usernameLabel: 'Username',
      usernamePlaceholder: 'Enter username',
      usernameRequired: 'Username is required',
      usernameMinLength: 'Minimum 1 character',
      usernameMaxLength: 'Maximum 50 characters',
      emailLabel: 'Email',
      emailPlaceholder: 'email@example.com',
      emailRequired: 'Email is required',
      passwordLabel: 'Password',
      passwordPlaceholder: 'At least 4 characters',
      passwordRequired: 'Password is required',
      passwordMinLength: 'Minimum 4 characters',
      confirmPasswordLabel: 'Confirm Password',
      confirmPasswordPlaceholder: 'Confirm password',
      confirmPasswordRequired: 'Please confirm your password',
      submit: 'Register',
      hasAccount: 'Already have an account?',
      login: 'Login',
      loginLink: 'Login',
      success: 'Registration successful',
      minLength1: 'Min 1 character',
      maxLength50: 'Max 50 characters',
      minLength4: 'Min 4 characters',
      confirmLabel: 'Confirm Password',
      confirmPlaceholder: 'Confirm your password',
      confirmRequired: 'Please confirm your password',
    },
    password: {
      title: 'Change Password',
      accountLabel: 'Account',
      currentPassword: 'Current Password',
      currentPasswordPlaceholder: 'Enter current password',
      currentPasswordRequired: 'Password is required.',
      newPassword: 'New Password',
      newPasswordPlaceholder: 'At least 4 characters',
      newPasswordRequired: 'Password is required.',
      newPasswordMinLength: 'Password must be at least 4 characters.',
      newPasswordMaxLength: 'Maximum 50 characters.',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Confirm new password',
      confirmPasswordRequired: 'Please confirm your password.',
      confirmPasswordMismatch: 'Passwords do not match!',
      submit: 'Save Password',
    },
    passwordReset: {
      initTitle: 'Forgot Password',
      initSubtitle: 'Enter your registered email to receive a reset link',
      emailLabel: 'Email',
      emailPlaceholder: 'email@example.com',
      emailRequired: 'Email is required.',
      emailInvalid: 'Invalid email address.',
      sendResetLink: 'Send Reset Link',
      backToLogin: '← Back to login',
      finishTitle: 'Set New Password',
      linkInvalid: 'Invalid or expired link',
      newPassword: 'New Password',
      newPasswordPlaceholder: 'At least 4 characters',
      newPasswordRequired: 'Password is required.',
      newPasswordMinLength: 'Minimum 4 characters.',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Re-enter password',
      confirmPasswordRequired: 'Please confirm your password.',
      confirmPasswordMismatch: 'Passwords do not match!',
      saveNewPassword: 'Save New Password',
    },
    deposit: {
      title: 'Deposit',
      bankMaintenance: 'Bank is under maintenance',
      amountLabel: 'Amount (VND)',
      amountPlaceholder: 'Enter deposit amount...',
      pay: 'Pay',
      depositHistory: 'Deposit History',
      code: 'Code',
      amount: 'Amount',
      status: 'Status',
      note: 'Note',
      date: 'Date',
      statusSuccess: 'Success',
      statusFailed: 'Failed',
      statusProcessing: 'Processing',
      checkStatus: 'Check Status',
      success: 'Success',
      failed: 'Failed',
      processing: 'Processing',
      noteSuccess: 'Deposit successful',
      noteFailed: 'Deposit failed',
      methodBank: 'Bank',
      methodCrypto: 'Crypto',
      cryptoHint: 'Choose network & coin next.',
    },
    depositDialog: {
      title: 'Deposit',
      creating: 'Creating transaction...',
      transferCode: 'Transfer Code',
      paymentSuccess: 'Payment Successful!',
      waitingPayment: 'Waiting for payment...',
      autoCheck: 'Auto-checking every 5 seconds',
      error: 'Error',
      cannotCreate: 'Cannot create transaction',
      successTitle: 'Success',
      successText: 'Payment successful!',
      close: 'Close',
      qrAlt: 'QR Code',
      success: 'Payment successful!',
      waiting: 'Waiting for payment...',
      expired: 'Invoice expired',
      expiredDesc: 'Please create a new invoice',
      createNew: 'Create new invoice',
      remaining: 'Remaining',
    },
    cryptoDialog: {
      title: 'Pay with Crypto',
      loading: 'Loading coins...',
      disabled: 'Crypto payment is not enabled',
      pickNetwork: 'Select network',
      pickCoin: 'Select coin',
      amount: 'Deposit amount',
      continue: 'Continue',
      creating: 'Creating order...',
      error: 'Error',
      cannotCreate: 'Cannot create crypto order',
      remaining: 'Remaining',
      expired: 'Order expired',
      networkWarning: 'Send only',
      viaNetwork: 'via network',
      sendExactly: 'Send exactly',
      address: 'Receiving address',
      tapToCopy: 'tap to copy',
      copy: 'Copy',
      success: 'Payment received — deposit successful!',
      waiting: 'Waiting for payment...',
      received: 'Received',
      successTitle: 'Success',
      successText: 'Wallet credited!',
      simulate: '[TESTNET] Simulate payment received',
    },
    depositWidget: {
      currentRank: 'Current Rank',
      progressTo: 'Progress to',
      depositMore: 'Deposit',
      toUpgrade: 'more to rank up',
      discountAll: 'Get',
      allOrders: 'off all orders',
      highestRank: "You've reached the highest rank!",
      highestRankDiscount: 'Get',
      viewDetails: 'View membership details →',
    },
    order: {
      adminTitle: 'Order Management',
      userTitle: 'Order History',
      refresh: 'Refresh',
      searchPlaceholder: 'Search order code...',
      searchPlaceholderAdmin: 'Search order code or username...',
      downloadAll: 'Download All',
      downloadFiltered: 'Download Filtered',
      downloading: 'Downloading...',
      quickFilter: 'Quick',
      dateRange: 'Date Range',
      apply: 'Apply',
      clear: 'Clear',
      allTime: 'All',
      '12h': '12 hours',
      '24h': '24 hours',
      '3d': '3 days',
      '7d': '7 days',
      '30d': '30 days',
      selected: 'Selected',
      selectedOrders: 'orders',
      downloadSelected: 'Download Selected',
      deleteSelected: 'Delete Selected',
      tableHeaders: {
        user: 'User',
        code: 'Code',
        productId: 'Product ID',
        mailType: 'Mail Type',
        quantity: 'Qty',
        total: 'Total',
        status: 'Status',
        createdDate: 'Created',
      },
      success: 'Success',
      failed: 'Failed',
      noResults: 'No matching orders found',
      noOrders: 'No orders yet',
      orderDetail: 'Order Detail',
      orderCodeLabel: 'Order Code',
      typeLabel: 'Type',
      quantityLabel: 'Qty',
      totalLabel: 'Total',
      copyEmail: 'Copy email|pass',
      copyFull: 'Copy full',
      download: 'Download .txt',
      view: 'View',
      downloadShort: 'Download',
      copySuccess: 'Copied successfully',
      downloadSuccess: 'Downloaded',
      downloadedOrders: 'orders',
      downloadError: 'Download failed',
      noDataToDownload: 'No data to download',
      deleteConfirm: 'Delete',
      deleteConfirmSuffix: 'selected orders?',
      deleted: 'Deleted',
      selectDateRange: 'Please select both start and end dates',
      startBeforeEnd: 'Start date must be before end date',
    },
    menu: {
      home: 'Home',
      manageUsers: 'Manage Users',
      manageBanks: 'Manage Banks',
      manageDeposits: 'Manage Deposits',
      manageOrders: 'Manage Orders',
      manageMails: 'Manage Mails',
      manageRanking: 'Manage Ranking',
      profile: 'Profile',
      deposit: 'Deposit',
      orderHistory: 'Order History',
    },
    announcement: {
      promotion: 'Promotion',
      update: 'Update',
      advertisement: 'Advertisement',
      info: 'Information',
      dontShowAgain: "Don't show again",
      next: 'Next',
      understood: 'Got it',
    },
    pagination: {
      show: 'Show',
      perPage: '/ page',
    },
    footer: {
      copyright: '© 2025 Q8Tools. Unauthorized use is prohibited.',
      terms: 'Terms',
      privacy: 'Privacy',
      telegram: 'Telegram ↗',
    },
    authMenu: {
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      profile: 'Profile',
      settings: 'Settings',
    },
    notifications: {
      promotion: 'Promotion',
      update: 'Update',
      advertisement: 'Advertisement',
      dontShowAgain: "Don't show again",
      close: 'Close',
    },
    profile: {
      title: 'Profile',
      account: 'Account',
      email: 'Email',
      memberRank: 'Member Rank',
      balance: 'Balance',
      apiKey: 'API Key',
      copiedApiKey: 'API Key copied',
      changePassword: 'Change Password',
      changeApiKey: 'Change API Key',
      changeApiKeySuccess: 'API Key changed successfully',
      currentRank: 'Current Rank',
      benefit: 'Benefit',
      totalDepositInPeriod: 'Total deposits in last',
      daysAgo: 'days',
      progressTo: 'Progress to',
      discount: 'Discount',
      minDeposit: 'Min. Deposit',
      within: 'Within',
      days: 'days',
      depositMoreHint: 'Deposit',
      inDaysToUpgrade: 'days to reach',
      andGetDiscount: 'and get',
      highestRank: "You've reached the highest rank!",
    },
    toolCommon: {
      complete: 'Complete',
      errorOccurred: 'An error occurred',
      copySuccess: 'Copied successfully',
      progress: 'Progress',
      lines: 'lines',
      noResult: 'No results yet',
      checking: '⏳ Checking...',
      startCheck: '▶ Start checking',
      processing: '⏳ Processing...',
    },
    toolCheckMail: {
      mailList: 'Mail List',
      startCheck: '▶ Start checking',
    },
    toolCheckUid: {
      uidList: 'UID List',
      placeholder: 'UID (one per line)',
      checkLive: '▶ Check live',
    },
    toolGetCode: {
      fillMailList: 'Please enter mail list',
      selectEmailType: 'Please select email type',
      stt: '#',
      content: 'Content',
      time: 'Time',
      errorBadge: 'Error',
    },
    toolReadMail: {
      title: '📬 Read Mailbox',
      reading: '⏳ Reading...',
      readMailbox: '▶ Read Mailbox',
      stt: '#',
      from: 'From',
      preview: 'Preview',
      time: 'Time',
      noEmail: 'No emails',
      view: 'View',
    },
    toolGet2fa: {
      placeholder: 'Enter secret key...',
      getCode: 'Get Code',
      clickToCopy: 'Click to copy',
      enterKeyPrompt: 'Enter key and click Get Code',
      newCodeIn: 'New code in',
      seconds: 's',
      errorGet2fa: 'Error getting 2FA code',
    },
    toolSuspended: {
      title: 'Feature temporarily unavailable',
      contactAdmin: 'Please contact admin for more information',
      contactTelegram: 'Contact via Telegram',
    },
    toolRegisterMail: { title: '📝 Register HotMail' },
    toolUnlockMail: { title: '🔓 Unlock HotMail' },
    toolRegisterYahoo: { title: '📨 Register Yahoo' },
    termPage: {
      title: '📜 Terms of Service',
      section1Title: '1. Introduction',
      section1Content: 'Welcome to Q8Tools. By using our service, you agree to comply with the following terms.',
      section2Title: '2. Services',
      section2Content: 'We provide high-quality email accounts for legitimate marketing and advertising purposes.',
      section3Title: '3. Accounts',
      section3Content: 'Each email account is sold only once. Buyers are responsible for securing their account credentials.',
      section4Title: '4. Payment',
      section4Content: 'Payment via bank transfer. Deposited balances are non-refundable.',
      section5Title: '5. Data',
      section5Content: 'Order data is automatically deleted after 48 hours. Please download before the deadline.',
      section6Title: '6. Liability',
      section6Content: 'We are not responsible if accounts are locked due to email provider policy violations.',
      section7Title: '7. Contact',
      section7Content: 'For any questions, please contact us via Telegram.',
      contact: 'Contact:',
    },
    policyPage: {
      title: '🔐 Privacy Policy',
      dataWeStore: 'Data we store:',
      email: 'Your email address',
      password: 'Encrypted password',
      balance: 'Current balance',
      depositHistory: 'Deposit history and payment details',
      orderHistory: 'Purchase history (72 hours)',
      deleteAccount: 'You can request account deletion by contacting us via',
      deleteDelay: '. Deletion will be processed no sooner than 48 hours.',
    },
    userProfile: {
      title: '👤 Personal Information',
      account: 'Account',
      memberRank: 'Member Rank',
      balance: 'Balance',
      apiKey: 'API Key',
      copiedApiKey: 'API Key copied',
      changedApiKey: 'API Key changed successfully',
      changePassword: '🔒 Change Password',
      changeApiKey: '🔄 Change API Key',
      membershipTitle: '👑 Membership',
      currentRank: 'Current Rank',
      benefit: 'Benefit',
      discount: 'Discount',
      allOrders: 'all orders',
      totalDeposit: 'Total deposits in last',
      daysAgo: 'days',
      progressTo: 'Progress to',
      minDeposit: 'Min. Deposit',
      within: 'Within',
      days: 'days',
      depositMore: 'Deposit',
      inDays: 'in',
      toUpgrade: 'days to reach',
      andGetDiscount: 'and get',
      highestRank: "You've reached the highest rank!",
    },
    systemSettings: {
      title: 'System Settings',
      orderGroup: 'Orders',
      maxRetention: 'Maximum order retention days',
      maxRetentionDesc: 'Orders will be automatically deleted after this many days',
      save: 'Save Settings',
      saveSuccess: 'Settings saved',
      days: 'days',
      telegramGroup: 'Telegram',
      botToken: 'Bot Token',
      botTokenDesc: 'Telegram Bot token',
      chatId: 'Chat ID',
      chatIdDesc: 'Chat group ID for notifications',
      enabled: 'Enable notifications',
      websiteGroup: 'Website',
      siteName: 'Site name',
      contactTelegram: 'Contact Telegram',
      savedKey: 'Saved',
    },
    orderRetention: {
      title: 'Order Retention',
      description: 'Orders will be automatically deleted after your chosen period',
      day: 'day',
      days: 'days',
      saveSuccess: 'Updated successfully',
      max: 'Maximum',
      autoDeleteInfo: 'Auto-delete after',
      changeInProfile: 'Change',
    },
    pageNotFound: {
      title: 'Page Not Found',
      description: 'The page you are looking for does not exist or has been removed.',
      backHome: '← Back to Home',
    },
    passwordStrength: {
      label: 'Password strength:',
    },
    headerMisc: {
      login: 'Login',
      products: 'Products',
    },
    common: {
      cancel: 'Cancel',
      confirm: 'Confirm',
      close: 'Close',
      copySuccess: 'Copied successfully',
      error: 'Error',
      loading: 'Loading...',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      search: 'Search',
      noData: 'No data',
      show: 'Show',
      perPage: '/ page',
    },
  },
} as const;

// ─── Types ──────────────────────────────────────────────────────

type Lang = 'vi' | 'en';
type Translations = typeof translations;
type TranslationTree = Translations[Lang];

interface LanguageContextValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
}

// ─── Context ────────────────────────────────────────────────────

const LanguageContext = createContext<LanguageContextValue>({
  lang: 'vi',
  setLang() {},
});

// ─── Provider ───────────────────────────────────────────────────

const STORAGE_KEY = 'app-lang';

const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLangState] = useState<Lang>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'vi' || stored === 'en') return stored;
    } catch {
      // SSR or localStorage unavailable
    }
    return 'vi';
  });

  const setLang = useCallback((newLang: Lang) => {
    setLangState(newLang);
    try {
      localStorage.setItem(STORAGE_KEY, newLang);
    } catch {
      // ignore
    }
  }, []);

  return React.createElement(LanguageContext.Provider, { value: { lang, setLang } }, children);
};

// ─── Hook ───────────────────────────────────────────────────────

function getNestedValue(obj: any, path: string): string {
  const keys = path.split('.');
  let current = obj;
  for (const key of keys) {
    if (current == null || typeof current !== 'object') return path;
    current = current[key];
  }
  return typeof current === 'string' ? current : path;
}

function useTranslation() {
  const { lang } = useContext(LanguageContext);
  const t = useCallback(
    (key: string, options?: { defaultValue?: string }): string => {
      const value = getNestedValue(translations[lang], key);
      // getNestedValue trả về chính key khi không tìm thấy -> dùng defaultValue làm fallback
      return value === key && options?.defaultValue != null ? options.defaultValue : value;
    },
    [lang],
  );
  return { t, lang };
}

// ─── LanguageSwitcher ───────────────────────────────────────────

const switcherStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '4px 10px',
  borderRadius: '999px',
  border: `1px solid ${colors.border}`,
  background: colors.surface,
  color: colors.text,
  cursor: 'pointer',
  fontSize: '13px',
  fontWeight: 500,
  transition: 'all 0.2s ease',
  userSelect: 'none' as const,
};

const switcherHoverStyle: React.CSSProperties = {
  borderColor: colors.accent,
  background: colors.accentDim,
};

const FlagVN: React.FC = () =>
  React.createElement(
    'svg',
    { width: 20, height: 14, viewBox: '0 0 30 20', style: { borderRadius: 2, flexShrink: 0 } },
    React.createElement('rect', { width: 30, height: 20, fill: '#DA251D' }),
    React.createElement('polygon', {
      points: '15,3.5 16.76,9.04 22.7,9.04 17.97,12.46 19.73,18 15,14.58 10.27,18 12.03,12.46 7.3,9.04 13.24,9.04',
      fill: '#FFFF00',
    }),
  );
const FlagGB: React.FC = () =>
  React.createElement(
    'svg',
    { width: 20, height: 14, viewBox: '0 0 60 30', style: { borderRadius: 2, flexShrink: 0 } },
    React.createElement('clipPath', { id: 'fgb' }, React.createElement('rect', { width: 60, height: 30 })),
    React.createElement(
      'g',
      { clipPath: 'url(#fgb)' },
      React.createElement('rect', { width: 60, height: 30, fill: '#012169' }),
      React.createElement('path', { d: 'M0,0L60,30M60,0L0,30', stroke: '#fff', strokeWidth: 6 }),
      React.createElement('path', { d: 'M0,0L60,30M60,0L0,30', stroke: '#C8102E', strokeWidth: 2 }),
      React.createElement('path', { d: 'M30,0V30M0,15H60', stroke: '#fff', strokeWidth: 10 }),
      React.createElement('path', { d: 'M30,0V30M0,15H60', stroke: '#C8102E', strokeWidth: 6 }),
    ),
  );

const LanguageSwitcher: React.FC = () => {
  const { lang, setLang } = useContext(LanguageContext);
  const [hovered, setHovered] = useState(false);

  const toggle = () => setLang(lang === 'vi' ? 'en' : 'vi');

  const viActive = lang === 'vi';

  const pillStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0,
    padding: 0,
    borderRadius: 999,
    border: `1px solid ${colors.border}`,
    background: colors.surface,
    cursor: 'pointer',
    fontSize: 12,
    fontWeight: 600,
    overflow: 'hidden',
    transition: 'all 0.2s ease',
    userSelect: 'none' as const,
    ...(hovered ? { borderColor: colors.accent } : {}),
  };

  const segStyle = (active: boolean): React.CSSProperties => ({
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    padding: '5px 12px',
    background: active ? colors.accent : 'transparent',
    color: active ? '#000' : colors.dim,
    transition: 'all 0.2s ease',
    fontWeight: active ? 700 : 500,
  });

  return React.createElement(
    'button',
    {
      type: 'button' as const,
      onClick: toggle,
      onMouseEnter: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
      style: pillStyle,
      'aria-label': 'Switch language',
    },
    React.createElement('span', { style: segStyle(viActive) }, React.createElement(FlagVN), 'VI'),
    React.createElement('span', { style: segStyle(!viActive) }, React.createElement(FlagGB), 'EN'),
  );
};

// ─── Exports ────────────────────────────────────────────────────

export { LanguageContext, LanguageProvider, useTranslation, LanguageSwitcher, translations };
export type { Lang, LanguageContextValue };
